/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */

/**
 * Numbering sequence: P (per premise) or N (per device)
 */
export type GetFinaSettings200NumberingSequence = typeof GetFinaSettings200NumberingSequence[keyof typeof GetFinaSettings200NumberingSequence];


export const GetFinaSettings200NumberingSequence = {
  N: 'N',
  P: 'P',
} as const;
